<template>
    <form @submit.prevent="createOrUpdatePersonal()">
        <h6 class="heading-small text-muted mb-4">ข้อมูลส่วนตัว</h6>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ชื่อ-สกุลเจ้าของร้าน <span class="text-red">(ภาษาไทย)</span>
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อ-สกุลเจ้าของร้าน (ภาษาไทย)"
                        :class="{ 'is-invalid': submitEdit && $v.personal.ownerName.$error }"
                        v-model="personal.ownerName"
                    />
                    <!-- vuelidate -->
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.personal.ownerName.minLength"
                    >กรุณากรอก"ชื่อเจ้าของ"อย่างน้อย {{$v.personal.ownerName.$params.minLength.min}} ตัวอักษร</label>
                    <span
                        v-if="submitEdit && !$v.personal.ownerName.required"
                        class="invalid-feedback"
                    >กรุณากรอกชื่อเจ้าของ</span>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ชื่อ-สกุลเจ้าของร้าน <span class="text-red">(ภาษาอังกฤษ)</span>
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อ-สกุลเจ้าของร้าน (ภาษาอังกฤษ)"
                        :class="{ 'is-invalid': submitEdit && $v.personal.ownerNameEng.$error }"
                        @input="personal.ownerNameEng = swapText(personal.ownerNameEng)"
                        v-model="personal.ownerNameEng"
                    />
                    <!-- vuelidate -->
                    <span
                        v-if="submitEdit && !$v.personal.ownerNameEng.required"
                        class="invalid-feedback"
                    >กรุณากรอกชื่อเจ้าของ</span>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> เลขบัตรประชาชน
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="เลขบัตรประชาชน/ประจำตัวผู้เสียภาษี"
                        v-model="personal.ownerTaxId"
                    />
                    <!-- vuelidate -->
                    <label
                        v-if="submitEdit && !$v.personal.ownerTaxId.required"
                        class="invalid-feedback"
                    >กรุณากรอกเลขบัตรประชาชน</label>
                    <span
                        class="error-message"
                        v-if="!$v.personal.ownerTaxId.required || !$v.personal.ownerTaxId.minLength"
                    >
                        กรุณากรอก "เลขบัตรประชาชน" {{$v.personal.ownerTaxId.$params.minLength.min}} ตัวเลข
                    </span>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> เบอร์โทรศัพท์ส่วนตัว
                    </label>
                    <input
                        type="number"
                        class="form-control hide-arrow"
                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                        placeholder="เบอร์โทรศัพท์ส่วนตัว"
                        :class="{ 'is-invalid': submitEdit && $v.personal.ownerTel.$error }"
                        v-model="personal.ownerTel"
                    />
                    <!-- vuelidate -->
                    <label
                        v-if="submitEdit && !$v.personal.ownerTel.required"
                        class="invalid-feedback"
                    >กรุณากรอกเบอร์โทรศัพท์ส่วนตัว</label>
                    <span
                        class="error-message"
                        v-if="!$v.personal.ownerTel.required || !$v.personal.ownerTel.minLength"
                    >
                        กรุณากรอก "เบอร์โทรศัพท์ส่วนตัว" อย่างน้อย {{$v.personal.ownerTel.$params.minLength.min}} ตัวเลข
                    </span>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        Email
                    </label>
                    <div class="input-group">
                        <input
                            disabled
                            type="text"
                            class="form-control"
                            placeholder="Email"
                            v-model="personal.ownerEmail"
                        />
                        <div class="input-group-append">
                            <b-button
                                class="btn px-3 btn-sm btn-info"
                                v-if="$USER_LOGIN.get().isSuperadmin || $USER_LOGIN.get().isShippop"
                                @click="$bvModal.show('modalEditAccount')"
                            >แก้ไขบัญชี</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        LINE ID (เพื่อรับข่าวสาร)
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="LINE ID (เพื่อรับข่าวสาร)"
                        v-model="personal.ownerIdLine"
                    />
                </div>
            </div>
        </div>
        <template v-if="$THEME.LineConfig.shopBank">
            <hr class="my-4" />
            <BranceBank
                :modalShop="modalShop"
                :modalPromptPay="personal.modalPromptPay"
                :shopBank="shopBank"
                @editBankUser="editBankUser"
                @emitReloadShopBank="emitReloadShopBank"
                @deletedShopBank="deletedShopBank"
            />
        </template>
        <hr class="my-4"/>
            <BrancePayment
                :personal="personal"
                :disablePayment="['admin', 'member'].includes($USER_LOGIN.get().details.role)"
                @setWallet="setWallet($event)"
            />
        <hr class="my-4" />
            <BranceSale
                :personal="personal"
            />
        <template v-if="$USER_LOGIN.get().isAdmin">
            <hr class="my-4" />
            <div class="mt-4 w-100 text-right">
                <b-button variant="secondary" @click="resetForm()">กรอกใหม่</b-button>
                <b-button type="submit" variant="info">บันทึก</b-button>
            </div>
        </template>
    </form>
</template>

<script>
import {
  required,
  minLength
} from "vuelidate/lib/validators"
import swapLang from "../../../plugins/swapLang.js"
import validatePop from "@/plugins/validatePop.js"
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import BrancePayment from "./BrancePayment.vue";
import BranceSale from "./BranceSale.vue";
import BranceBank from "./BranceBankDetail.vue";

export default {
    name: "BrancePersonal",
    props: {
        shopBank   : Array,
        submitEdit: Boolean,
        personal   : Object,
        wallet     : Object,
        modalShop  : Object,
    },
    validations: {
        personal: {
            ownerName   : { required, minLength: minLength(2) },
            ownerNameEng: { required },
            ownerTaxId  : { required, minLength: minLength(13) },
            ownerTel    : { required, minLength: minLength(9) },
        }
    },
    methods: {
        deletedShopBank(getId) {
            return this.$emit('deletedShopBank', getId)
        },
        editBankUser(infoId) {
            return this.$emit('editBankUser', infoId)
        },
        emitReloadShopBank() {
            return this.$emit('emitReloadShopBank')
        },
        createOrUpdatePersonal() {
            this.$emit("update:submitEdit", true);
            this.$v.personal.$touch();
            if (this.$v.personal.$invalid) {
                return false;
            }
            this.$emit("handleLoader");
            this.$http
                .post(this.$API_URL + "/shop/shop/detail", {
                type             : "personal",
                owner_name       : this.personal.ownerName,
                owner_name_eng   : this.personal.ownerNameEng,
                owner_tel        : this.personal.ownerTel,
                id_line          : this.personal.ownerIdLine,
                tax_shop         : this.personal.ownerTaxId,
                payment_type     : this.personal.paymentType,
                payment_condition: this.personal.paymentCondition,
            }, {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            })
                .then(res => {
                let checkError = validatePop(res);
                this.$emit("handleLoader");
                if (!checkError.status) {
                    showErrorModal(checkError.msg);
                    return false;
                }
                showSuccessModal("บันทึกข้อมูลส่วนตัวสำเร็จ");
            })
                .catch(error => {
            });
        },
        swapText(text) {
            let swap = text.split("");
            let swapText = "";
            swap.forEach(value => {
                if (swapLang[value]) {
                    swapText += swapLang[value];
                }
                else {
                    swapText += value;
                }
            });
            return swapText;
        },
        resetForm() {
            Object.keys(this.personal).forEach(key => {
                if (["ownerIdLine", "ownerName", "ownerNameEng", "ownerTaxId", "ownerTel"].includes(key)) {
                    this.personal[key] = "";
                }
            });
        },
        setWallet( status ){
            this.wallet.status = status
        }
    },
    components: {
        BrancePayment,
        BranceSale,
        BranceBank
    },
    mounted() {

    }
}
</script>

<style>
.error-message {
  color: #E2495F;
  font-size: 14px;
  margin-top: 5px;
  display: block;
}
</style>
